<template>
  <div class="infoPage">
    <div class="infoHeader">
      <font-awesome-icon icon="heart" class="w3-right headerIcon" /><h2>{{$t('info.donate.header')}}</h2>
    </div>
    <div class="infoText">   
      <p>{{$t('info.donate.intro')}}</p>
      <p>{{$t('info.donate.paragraph1')}}</p>
      <p>{{$t('info.donate.paragraph2')}}</p>
      <p>{{$t('info.donate.paragraph3')}}</p>
      <p>{{$t('info.donate.paragraph4')}}</p>
      <p>{{$t('info.donate.paragraph5')}}</p>
      <a href="https://buymeacoffee.com/chessadmin" target="_new"><img :src="buymeacoffee" ></a>

      <p>Je kunt ook doneren via een betaalverzoek/iDeal. Deze staat ingesteld op 5 euro, het bedrag is aanpasbaar door de gebruiker. Gebruik hiervoor de link hieronder.</p>
      <a href="https://www.ing.nl/particulier/betaalverzoek/index.html?trxid=rz938M0Ydh83wOyrne8Q7fhFr3TjcLzt" target="_new"><img :src="betaalverzoek" ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Donate',
  props: {
    msg: String
  },
  data () {
    return {
      buymeacoffee: require('../../assets/img/buymeacoffee_ca.png'),
      betaalverzoek: require('../../assets/img/betaalverzoek.jpg')
    }
  }
}
</script>


<!--
<script type="text/javascript" src="https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js" 
data-name="bmc-button" 
data-slug="chessadmin" data-color="#365c96" data-emoji=""  
data-font="Arial" data-text="Buy me a coffee" data-outline-color="#ffffff" 
data-font-color="#ffffff" data-coffee-color="#FFDD00" ></script>

 Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

img {
  width: 200px;
}
</style>



